<template>
  <div id="information" class="c-content">
    <div class="c-information">
      <div class="c-standard">
        <div class="c-information__title">
          <p class='font_back' @click="$router.push({name: 'aboutus', query: {anchor: 'info'}})">{{ information.backBtn }}</p>
          <h3 class='title_h3' v-if="languageDefault == 'en_us'">{{items[index].title_en}}</h3>
          <h3 class='title_h3' v-else-if="languageDefault == 'de_de'">{{items[index].title_de}}</h3>
          <h3 class='title_h3' v-else>{{items[index].title}}</h3>
          <span v-if="languageDefault == 'en_us'">{{items[index].datetime_en}}</span>
          <span v-else-if="languageDefault == 'de_de'">{{items[index].datetime_de}}</span>
          <span v-else>{{items[index].datetime}}</span>
        </div>
        <div class="c-information__items">
          <div class="c-information__item" v-for="item in items[index].content" :key="item.id">
            <div class="c-information__item--img" v-if="item.type == 1">
              <img :class="item.class ? item.class : ''" :src="item.img" alt="">
            </div>
            <div class="c-information__item--text" v-else-if="item.type == 2">
              <p :class="item.class ? item.class : ''">{{ item.content }}</p>
            </div>
            <div class="c-information__item--title" v-else-if="item.type == 3">
              <p :class="item.class ? item.class : ''">
                <span>{{ item.title1 }}</span>
                <span>{{ item.title2 }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="c-pageRoute">
          <div class="font_back c-pageRoute--btn">
            <p v-if="index > 0" @click="infoRouteTo('information', index-1 )">
              <span>{{ information.prev }}</span>
              <span v-if="languageDefault == 'en_us'">{{items[index - 1].title_en}}</span>
              <span v-else-if="languageDefault == 'de_de'">{{items[index - 1].title_de}}</span>
              <span v-else>{{items[index - 1].title}}</span>
            </p>
          </div>
          <div class="font_back c-pageRoute--btn">
            <p v-if="(parseInt(index)+1) < items.length" @click="infoRouteTo('information', index+1 )">
              <span>{{ information.next }}</span>
              <span v-if="languageDefault == 'en_us'">{{items[index + 1].title_en}}</span>
              <span v-else-if="languageDefault == 'de_de'">{{items[index + 1].title_de}}</span>
              <span v-else>{{items[index + 1].title}}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // import api from '../../api'
  // import axios from 'axios'

  export default {
    name: 'information',
    components: {
    },
    data(){
      return {
        information: {
          backBtn: this.$t('menu.information_back'),
          prev: this.$t('common.prev_info'),
          next: this.$t('common.next_info')
        },
        index: 0,
        languageDefault: localStorage.getItem('lang') || 'zh_cn',
        items:[
          {
            id: 0,
            title: '一路向前，未来可期---记瑞思特团建之旅',
            title_en: "一路向前，未来可期---记瑞思特团建之旅",
            title_de: "一路向前，未来可期---记瑞思特团建之旅",
            datetime: '2023-06-14',
            datetime_en: 'Jun 14, 2023',
            datetime_de: '14 Juni 2023',
            content:[
              {type: 2, class: 'textAlignCenter', content: '雄伟壮丽的长城'},
              {type: 2, class: 'textAlignCenter', content: '是每个国人心中的无限情怀'},
              {type: 2, class: 'textAlignCenter', content: '那些在山的脊线处蜿蜒不绝的长垣'},
              {type: 2, class: 'textAlignCenter l-margin-bottom-30', content: '撑起了一个民族的脊梁'},

              {type: 2, class: 'textAlignCenter', content: '在这个阳光明媚的夏日，'},
              {type: 2, class: 'textAlignCenter', content: '我们瑞思特智能科技的团队成员们'},
              {type: 2, class: 'textAlignCenter l-margin-bottom-80', content: '向着美丽的天津黄崖关长城出发啦'},

              {type: 3, title1: '01', title2: '初遇长城'},

              {type: 2, class: 'textAlignCenter', content: '黄崖关古长城位于天津蓟县北28公里'},
              {type: 2, class: 'textAlignCenter', content: '是明代长城的重要关隘'},
              {type: 2, class: 'textAlignCenter', content: '这里的长城蜿蜒曲折、气势磅礴'},
              {type: 2, class: 'textAlignCenter', content: '和八达岭长城还有慕田峪长城比较'},
              {type: 2, class: 'textAlignCenter', content: '有奇、险、俊、幽、古等奇观'},
              {type: 2, class: 'textAlignCenter l-margin-bottom-50', content: '一路攀爬沿途的风景美不胜收'},

              {type: 1, img: require('../../assets/img/news/01.jpg')},
              {type: 1, img: require('../../assets/img/news/02.jpg')},
              {type: 1, class: 'l-margin-bottom-80', img: require('../../assets/img/news/03.jpg')},

              {type: 3, title1: '02', title2: '艰难登顶'},

              {type: 2, class: 'textAlignCenter', content: '工作中我们全力以赴'},
              {type: 2, class: 'textAlignCenter', content: '登长城，我们也绝不含糊'},
              {type: 2, class: 'textAlignCenter', content: '面对陡峭的山路和高耸的城墙'},
              {type: 2, class: 'textAlignCenter', content: '我们鼓励着彼此，携手共进'},
              {type: 2, class: 'textAlignCenter', content: '团队队员活力四射，勇往直前'},
              {type: 2, class: 'textAlignCenter l-margin-bottom-50', content: '这种团队精神，正是我们瑞思特智能科技所倡导的企业文化'},

              {type: 1, img: require('../../assets/img/news/04.jpg')},
              {type: 1, img: require('../../assets/img/news/05.jpg')},
              {type: 1, img: require('../../assets/img/news/06.jpg')},
              {type: 1, class: 'l-margin-bottom-80', img: require('../../assets/img/news/07.jpg')},

              {type: 3, title1: '03', title2: '无限风景在顶峰'},

              {type: 2, class: 'textAlignCenter', content: '登顶之后，我们俯瞰着脚下的壮丽景色'},
              {type: 2, class: 'textAlignCenter', content: '感受着中华民族的伟大历史'},
              {type: 2, class: 'textAlignCenter', content: '我们更加坚定'},
              {type: 2, class: 'textAlignCenter', content: '只要我们团结一心'},
              {type: 2, class: 'textAlignCenter', content: '一定能够攀登科技的高峰，共筑辉煌未来'},
              {type: 2, class: 'textAlignCenter l-margin-bottom-50', content: '一路向前，未来可期，所遇皆是美好！'},

              {type: 1, img: require('../../assets/img/news/08.jpg')},
              {type: 1, class: 'l-margin-bottom-80', img: require('../../assets/img/news/09.jpg')},

              {type: 2, class: 'l-margin-bottom-80', content: '这次黄崖关长城团建之旅，不仅锻炼了我们的体魄，更加凝聚了我们的团队力量。在未来的日子里，瑞思特智能科技将继续秉承团队精神，为实现企业的愿景和使命而努力拼搏！'},

              {type: 1, img: require('../../assets/img/news/10.png')},
            ],
          },
          {
            id: 1,
            title: '为卫生院实训室安装电动橱柜升降台',
            title_en: "Installation of a Pressalit Kitchen desk and cupboard system",
            title_de: "Einrichtung einer barrierefreien Küche",
            datetime: '2023-02-08',
            datetime_en: 'Feb 08, 2023',
            datetime_de: '08 Feb. 2023',
            content:[
              {type: 1, img: require('../../assets/img/shanghai_antingzhen.jpg')},
              {type: 2, content: '地点：上海某镇卫生院 实训室'},
              {type: 2, content: '设备：升降台面 升降橱柜'},
              {type: 2, content: '特点：配置安全防压伤系统，确保使用者一个安全的下厨环境'},
              {type: 2, content: '我们的电动升降器，可以对大多墙壁橱柜和操作台面的高度进行调整，让坐着和站立的使用者都可以在厨房里舒适地操作。电动升降器适配标准的厨房组件，既可以用于新厨房装修，也可用于现有厨房的改造。'},
            ],
          },
          {
            id: 2,
            title: '参展第十五届 CHINA AID 博览会',
            title_en: "Our Booth on the 15th China Aid trade fair in Shanghai",
            title_de: "Unser Stand auf der 15ten China Aid Messe in Shanghai",
            datetime: '2020-10-30',
            datetime_en: 'Oct 30, 2020',
            datetime_de: '30 Okt. 2020',
            content:[
              {type: 1, img: require('../../assets/img/20201030_shanghai_chinaaid.jpg')},
              {type: 2, content: '第十五届中国国际养老、辅具及康复医疗博览会（简称CHINA AID）于2020年10月28-30日在上海新国际博览中心举行。中国国际养老、辅具及康复医疗博览会，自2000年在上海成功举办首届以来，经过多年的耕耘，已然成为国内颇具影响力的福祉产业品牌博览会，位居世界同类展会前列。瑞思特在本次博览会上展示了Senicare智慧养老起居室方案、卫生间方案以及机构移位机等最新设备。'},
              {type: 2, content: '瑞思特Senicare智慧养老品牌进入国内也已有数年，最早于2013年5月在上海第一次参展CHINA AID，并展示了已在德国广泛应用的智能化看护系统。'},
              {type: 2, content: '数年来，瑞思特不断结合中国长者生活方式的特点，将欧洲的自主体面的养老理念加以优化，并逐步引进了欧洲合作伙伴如Pressalit、Wissner-Bosserhoff等的助老设备，进一步完善了智慧养老系统方案。我们构建的智能化系统与平台，包括安全看护、交互通讯、智能家居、健康管理、生活服务等。'},
              {type: 2, content: '此次博览会，我们结识了来自全国各地的来访者，获得了交流机会，为进一步更好的服务客户积累了优质的资源。'},
            ],
          },
          {
            id: 3,
            title: '为学院实训室安装电动橱柜和升降台',
            title_en: "Installation of a Pressalit Kitchen desk and cupboard system",
            title_de: "Einrichtung einer barrierefreien Küche",
            datetime: '2020-09-22',
            datetime_en: 'Sep 22, 2020',
            datetime_de: '22 Sept. 2020',
            content:[
              {type: 1, img: require('../../assets/img/20200922_changzhou_shengjiangtai.jpg')},
              {type: 2, content: '地点：常州卫生职业技术学院  实训室'},
              {type: 2, content: '设备：升降台面 升降橱柜'},
              {type: 2, content: '特点：配置安全防压伤系统，确保使用者一个安全的下厨环境'},
              {type: 2, content: '我们的电动升降器，可以对大多的墙壁橱柜和操作台面的高度进行调整，让坐着和站立的使用者都可以在厨房里舒适地操作。电动升降器适配标准的厨房组件，既可以用于新厨房装修，也可用于现有厨房的改造。'},
            ],
          },
        ]
      }
    },
    computed: {

    },
    created () {
      this.index = this.getQueryVariable('id') ? parseInt(this.getQueryVariable('id')) : 0
    },
    methods: {
      getQueryVariable(variable) {
        let query
        if (window.location.href.indexOf('?') > -1) {
          query = window.location.href.split('?')[1]
        } else {
          query = ""
        }
        var vars = query.split("&");
        for (var i=0;i<vars.length;i++) {
          var pair = vars[i].split("=");
          if(pair[0] == variable){return pair[1];}
        }
        return(false);
      },
      infoRouteTo(link, index){
        this.$router.push({
          name: link,
          query: {
            id: index
          }
        })
      },
    },
    watch: {
      '$route' (){
        this.index = parseInt(this.getQueryVariable('id'))
      }
    }
  }
</script>

<style>

</style>
